import { FieldErrors } from 'entities/errors'
import { csrfToken } from 'rails-ujs'
import URLSearchParams from 'url-search-params'

export const csrfTokenInterceptor = config => {
  if (config.data instanceof FormData) {
    config.data.append('authenticity_token', csrfToken())
  }

  return {
    ...config,
    headers: {
      ...config.headers,
      'X-CSRF-TOKEN': csrfToken()
    }
  }
}

export const contentTypeInterceptor = config => {
  const contentTypeHeader = (() => {
    if (config.data instanceof FormData) {
      return {
        'Content-Type': 'multipart/form-data'
      }
    }

    if (config.data instanceof URLSearchParams) {
      return {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }

    return {
      'Content-Type': 'application/json'
    }
  })()

  return {
    ...config,
    headers: {
      Accept: 'application/json',
      ...config.headers,
      ...contentTypeHeader
    }
  }
}

export const removeEmptyRequestDataInterceptor = config => {
  if (config.data !== null) {
    return config
  }

  const newConfig = config
  delete newConfig.data
  return newConfig
}

export const parseErrorInterceptor = error => {
  const { response } = error
  const newError = error

  if (response.status === 422) {
    newError.fieldErrors = FieldErrors.fromJson(response.data.errors || [])
  }

  throw newError
}
